import { Check, Truck, Package, MapPin, Home, Clock, AlertTriangle, RotateCcw, PackageCheck } from "lucide-react";

const ICONS = {
    RECOLHIDO: Package,
    EM_TRANSITO: Truck,
    CENTRO_DISTRIBUICAO: MapPin,
    EM_DISTRIBUICAO: Truck,
    DISPONIVEL_LEVANTAMENTO: PackageCheck,
    ENTREGA_FALHADA: AlertTriangle,
    EXCECAO: AlertTriangle,
    DEVOLVIDO: RotateCcw,
    ENTREGUE: Home,
};

function formatPT(iso) {
    try {
        const d = new Date(iso);
        return d.toLocaleString("pt-PT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function StatusTimeline({ events }) {
    if (!events || events.length === 0) {
        return (
            <div className="border border-slate-200 p-8 text-center text-slate-500">
                <Clock className="mx-auto mb-2 w-5 h-5" />
                Ainda sem eventos.
            </div>
        );
    }

    // Show newest first
    const ordered = [...events].reverse();

    return (
        <ol data-testid="status-timeline" className="relative">
            {ordered.map((ev, i) => {
                const Icon = ICONS[ev.status_code] || Package;
                const isLatest = i === 0;
                return (
                    <li
                        key={`${ev.timestamp}-${i}`}
                        className="relative pl-12 pb-8 last:pb-0"
                        data-testid={`timeline-event-${ev.status_code}`}
                    >
                        {i !== ordered.length - 1 && (
                            <span className="absolute left-[18px] top-9 bottom-0 w-px bg-slate-200" />
                        )}
                        <span
                            className={`absolute left-0 top-0 w-9 h-9 flex items-center justify-center border ${
                                isLatest
                                    ? "bg-[var(--tp-orange)] text-white border-[var(--tp-orange)] tp-pulse"
                                    : "bg-white text-slate-600 border-slate-300"
                            }`}
                        >
                            <Icon className="w-4 h-4" />
                        </span>
                        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                            <h4 className="text-base font-bold text-slate-900">
                                {ev.status_label}
                            </h4>
                            <span className="text-xs font-mono text-slate-500">
                                {formatPT(ev.timestamp)}
                            </span>
                            {isLatest && (
                                <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--tp-orange)]">
                                    Mais recente
                                </span>
                            )}
                        </div>
                        <p className="mt-1 text-sm text-slate-600">{ev.description}</p>
                        <p className="mt-0.5 text-xs uppercase tracking-widest font-semibold text-slate-500">
                            {ev.location}
                        </p>
                    </li>
                );
            })}
        </ol>
    );
}
